import { render, staticRenderFns } from "./WritingPage.vue?vue&type=template&id=0cc36e43&"
import script from "./WritingPage.vue?vue&type=script&lang=js&"
export * from "./WritingPage.vue?vue&type=script&lang=js&"
import style0 from "./WritingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports